<template>
  <div class="ol-popup" :style="{'min-width': '50px'}">
    <b-row v-for="ident in idents" :key="ident">
      <b-col>
        <b-button size="sm" @click="emitValue(ident)"  :key="ident" variant="outline-primary">{{ident}}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    name: 'MultiPopup',
    props: {
      "idents": {
        default: () => []
      },
      "identName": {
        default: () => []
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/designotron/MultiPopup.vue